import { useState, useEffect } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import SearchSelect from "components/selects/SearchSelect";
import useCustomTranslation from "core/customTranslation";
import translations from "../../../reports/translations";

const FormFiltersModel = {
    measure_min: "",
    measure_max: "",
    filling_min: "",
    filling_max: "",
    searcher: "",
    waste_type: "",
    download_type: "",
    group: "",
    device_group: "",
    zone: "",
    route: "",
    island: "",
};

const WasteParamsModel = { groups: [], device_groups: [], zones: [], routes: [], islands: [] };

const MeasureFilters = ({ filters, params = { ...WasteParamsModel } }) => {
    const { t: tC } = useCustomTranslation(translations);
    const labelStyle = { width: "100%", fontWeight: "bold", textAlign: "center" };
    const [formFilters, setFormFilters] = useState({ ...FormFiltersModel });

    // Actualizar los selectores cuando cambien los params
    useEffect(() => {
        // No resetear los filtros, solo asegurar que se renderizen correctamente
    }, [params]);

    const updateChosenFilter = (name, value) => {
        value ? (filters.current.chosen[name] = value) : delete filters.current.chosen[name];
    };

    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        setFormFilters({ ...formFilters, [name]: value });
        updateChosenFilter(name, value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormFilters({ ...formFilters, [name]: value.trim() });
        updateChosenFilter(name, value);
    };

    const handleClearFilters = () => {
        filters.current.chosen = {};
        setFormFilters({ ...FormFiltersModel });
        filters.current.filter();
    };

    const applyAllFilters = () => {
        filters.current.filter();
    };

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{ color: "black" }} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col" style={{ maxWidth: "160px" }}>
                        <label style={labelStyle}>{tC("filters.downloadType")}</label>
                        <DownloadTypesSelect multiple={false} value={formFilters.download_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{ maxWidth: "160px" }}>
                        <label style={labelStyle}>{tC("filters.wasteType")}</label>
                        <WasteTypesSelect multiple={false} value={formFilters.waste_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{tC("filters.groups")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: tC("filters.all") },
                                ...params.groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.groups
                                    .filter((g) => g.id === formFilters.group)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    group: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.group = option.value;
                                } else {
                                    delete filters.current.chosen.group;
                                }
                            }}
                        />
                    </div>
                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{tC("filters.device_groups")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: tC("filters.all") },
                                ...params.device_groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.device_groups
                                    .filter((g) => g.id === formFilters.device_group)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    device_group: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.device_group = option.value;
                                } else {
                                    delete filters.current.chosen.device_group;
                                }
                            }}
                        />
                    </div>
                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{tC("filters.zones")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: tC("filters.all") },
                                ...params.zones.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    zone: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.zone = option.value;
                                } else {
                                    delete filters.current.chosen.zone;
                                }
                            }}
                            value={
                                params.zones
                                    .filter((g) => g.id === formFilters.zone)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{tC("filters.routes")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: tC("filters.all") },
                                ...params.routes.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    route: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.route = option.value;
                                } else {
                                    delete filters.current.chosen.route;
                                }
                            }}
                            value={
                                params.routes
                                    .filter((g) => g.id === formFilters.route)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{ maxWidth: "200px" }}>
                        <label style={labelStyle}>{tC("filters.islands")}</label>
                        <SearchSelect
                            options={[
                                { value: "", label: tC("filters.all") },
                                ...params.islands.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    island: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.island = option.value;
                                } else {
                                    delete filters.current.chosen.island;
                                }
                            }}
                            value={
                                params.islands
                                    .filter((g) => g.id === formFilters.island)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>

                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={applyAllFilters}
                            className="btn btn-outline-primary me-3"
                            title={tC("filters.search")}>
                            <FontAwesomeIcon icon="magnifying-glass" /> {tC("filters.search")}
                        </button>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-1 h5 pt-3 text-center"></div>
                    <div className="col mb-3" style={{ maxWidth: "250px" }}>
                        <label style={labelStyle}>UUID / UID</label>
                        <input
                            type="text"
                            className="form-control"
                            name="searcher"
                            value={formFilters.searcher}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col" style={{ maxWidth: "260px" }}>
                        <label style={labelStyle}>{tC("filters.measure")} (cm)</label>
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="measure_min"
                                    placeholder={tC("filters.minimum")}
                                    value={formFilters.measure_min}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="measure_max"
                                    placeholder={tC("filters.maximum")}
                                    value={formFilters.measure_max}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col" style={{ maxWidth: "260px" }}>
                        <label style={labelStyle}>{tC("filters.filling")} (%)</label>
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="filling_min"
                                    placeholder={tC("filters.minimum")}
                                    value={formFilters.filling_min}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="filling_max"
                                    placeholder={tC("filters.maximum")}
                                    value={formFilters.filling_max}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default MeasureFilters;
